import React, {useEffect, useMemo, useRef, useState} from 'react'
import {Button, Card, CloseButton, Col, Form, Row} from "react-bootstrap";
import {PlusLg} from "react-bootstrap-icons";
import NewMilestonesItem from "../Partials/NewMilestonesItem";
import {useLocation} from "react-router-dom";

export default function Milestones({milestones, onChange, trls, isValidating, startValidating, milestonesGenerated, correctDates, teamMembers, resultsImpact}){
    const location = useLocation()
    const [notPassedMilestone, setNotPassedMilestone] = useState(null)
    const [milestonesPassed, setMilestonesPassed] = useState(false)
    const addButtonRef = useRef(null)
    const alreadyScrolled = useRef(false)

    useEffect(() => {
        if (milestonesGenerated && location.search.split('&').includes('milestones=1') && !alreadyScrolled.current){
            const notPassedMilestone = milestones.find((value) => !value.name || !value.monthPlan || !value.personsInCharge ||
                value.personsInCharge.length === 0)
            setNotPassedMilestone(notPassedMilestone)
            if (!notPassedMilestone){
                setMilestonesPassed(true)
            }
            alreadyScrolled.current = true
        }
    }, [milestones, milestonesGenerated])

    useEffect(() => {
        if (isValidating){
            setNotPassedMilestone(milestones.find((value) => !value.name || !value.monthPlan || !value.yearPlan ||
                !value.personsInCharge || value.personsInCharge.length === 0))
        }
    }, [startValidating, isValidating])

    useEffect(() => {
        if (location.search.split('&').includes('milestones=1') && milestonesPassed){
            const addButtonPos = addButtonRef.current.getBoundingClientRect()
            scrollTo(addButtonPos.x, window.scrollY + addButtonPos.y - window.screen.availHeight / 2)
        }
    }, [milestonesPassed])

    const trlsOptions = useMemo(() => trls.map((value) => ({
        label: `${value.id} - ${value.descr}`,
        value
    })), [trls])

    const personInChargeOptions = useMemo(() => (teamMembers?.data || []).filter((value) => value.status === 'approved')
        .map((value) => ({
            label: `${value.lastName} ${value.firstName} ${value.middleName} (${value.post})`,
            value
        })), [teamMembers])

    return (
    <Card className='mb-4'>
        <Card.Header as={Card.Title} className='p-4'>
            Вехи проекта
        </Card.Header>
        <Card.Body className='px-4'>
            {milestones.map((value, i) =>
                <NewMilestonesItem
                    milestones={milestones}
                    onChange={onChange}
                    data={value}
                    key={`milestone-${i}`}
                    index={i}
                    trlsOptions={trlsOptions}
                    personInChargeOptions={personInChargeOptions}
                    isValidating={isValidating}
                    correctDates={correctDates}
                    notPassedMilestone={notPassedMilestone}
                    setNotPassedMilestone={setNotPassedMilestone}
                    resultsImpact={resultsImpact || []}
                />)}
            <Button
                onClick={() => onChange((prevState) => [...prevState, {...defaultMilestone}])}
                variant='outline-primary'
                ref={addButtonRef}
            >
                <PlusLg className="me-1 mb-1"/>
                Добавить веху
            </Button>
        </Card.Body>
    </Card>
    )
}

const defaultMilestone = {
    name: '',
    monthPlan: '',
    yearPlan: '',
    projResultId: null,
    projResultOriginId: null
}